import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M18.5 44.6c-5.2-4.4-9.3-12.3.8-25.5l3.2-4.2-1 5.2c-.4 2.1-.8 8.1.8 11.7.7 1.6 1.6 2.4 2.3 2.6.1 0 .4.1.6 0 .4-.2.8-1.2-.1-3.3l-1.3-2.8 2.9 1.1c3.8 1.4 4.9 3.9 5.2 5.7.5 3.5-1.7 7.1-4.1 8.9l-1.5-2c1.8-1.3 3.5-4.1 3.2-6.6-.1-.9-.5-1.7-1.2-2.3 0 1.7-.7 2.9-1.7 3.4-.7.4-1.6.4-2.5.1-1.5-.5-2.9-2-3.8-4-1.1-2.4-1.4-5.6-1.4-8.3-4.5 7.5-4 13.7 1.5 18.2l-1.9 2.1z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M22.5 45.1c-8.9 0-16.2-7.3-16.2-16.2 0-6.4 4.4-10.8 8.3-14.7 4.3-4.3 6.8-7.1 5.1-10.8L18.2.1l3.2 1.7c6.4 3.3 9.3 7.9 8.4 13.6-.1.6-.2 1.2-.4 1.8-.3 1-.6 2.2-.4 2.8.2.5.4.8.9.8.7 0 1.6-.8 1.9-2.2l.5-2 1.6 1.3c1.8 1.5 3.3 4 4.1 6.5.4 1.4.6 2.8.6 4.5.1 8.9-7.2 16.2-16.1 16.2zm.3-39.6c.1 4-3.2 7.3-6.4 10.5-3.7 3.7-7.6 7.6-7.6 12.9 0 7.5 6.1 13.7 13.7 13.7 7.5 0 13.7-6.1 13.7-13.7 0-1.5-.2-2.7-.5-3.8-.4-1.4-1.2-2.9-2.1-4-.9 1.5-2.3 2.2-3.5 2.2-1.6 0-2.9-.9-3.3-2.6-.4-1.3 0-2.8.3-4.2.1-.6.3-1.1.3-1.5.5-3.8-1-7-4.6-9.5z"
	})]
});
export default SvgIcon;
